import { http } from "../api";
const easyUnpack = ({ data }) => data;
export const LassieTriggerApi = {
    create_lassie_trigger: {
        f: function create_lassie_trigger(scenario_id, { is_subsequent = null, min_peak_current = null, max_peak_current = null, min_probability = null, min_distance_km = null, max_distance_km = null, turbine_model = null }) {
            let url = '/lassie/trigger/$scenario_id/trigger';
            let parameterNames = ["$scenario_id"];[scenario_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
            return http.post(url, { is_subsequent, min_peak_current, max_peak_current, min_probability, min_distance_km, max_distance_km, turbine_model }).then(easyUnpack)
        }
    },
    create_lassie_predefined_trigger: {
        f: function create_lassie_predefined_trigger(scenario_id, { min_probability = null, max_distance_km = null, trigger_type = null }) {
            let url = '/lassie/trigger/$scenario_id/predefined-trigger';
            let parameterNames = ["$scenario_id"];[scenario_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
            return http.post(url, { min_probability, max_distance_km, trigger_type }).then(easyUnpack)
        }
    },
    delete_trigger: {
        f: function delete_trigger(trigger_id) {
            let url = '/lassie/trigger/$trigger_id'; let parameterNames = ["$trigger_id"];[trigger_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
            return http.delete(url, { data: {} }).then(easyUnpack)
        }
    },
    update_trigger: {
        f: function update_trigger(trigger_id, { is_subsequent = null, min_peak_current = null, max_peak_current = null, min_probability = null, min_distance_km = null, max_distance_km = null, turbine_model = null }) {
            let url = '/lassie/trigger/$trigger_id';
            let parameterNames = ["$trigger_id"];
            [trigger_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
            return http.put(url, { is_subsequent, min_peak_current, max_peak_current, min_probability, min_distance_km, max_distance_km, turbine_model }).then(easyUnpack)
        }
    },
};
